import {
	Recording,
	useUpdateRecordingMutation,
} from '@/apollo/gql/generated/graphql';
import React, { useCallback, useContext, useMemo } from 'react';

const RecorderContext = React.createContext<{
	status?: string;
	id?: string;
	recording?: Recording;
	setRecording?: (recording: Recording) => void;
	setRecordingStatus?: (status: string) => void;
	setRecordingId?: (id: string) => void;
	updateRecording?: (data: {
		isBackgroundOff?: boolean;
		instructorShared?: boolean;
		studentShared?: boolean;
	}) => Promise<void>;
}>({});

export const RecordingProvider = ({
	children,
}: {
	children: React.ReactNode;
}) => {
	const [recording, setRecording] = React.useState<Recording>();
	const [recordingStatus, setRecordingStatus] = React.useState<
		null | string | undefined
	>(null);
	const [updateRecordingMutation] = useUpdateRecordingMutation();
	const [recordingId, setRecordingId] = React.useState<string>();

	const updateRecording = useCallback(
		async (data: {
			isBackgroundOff?: boolean;
			instructorShared?: boolean;
			studentShared?: boolean;
		}) => {
			console.log({ recordingId });
			if (!recordingId) return;

			let infoToUpdate = {};
			if (data.instructorShared !== undefined) {
				infoToUpdate = {
					...infoToUpdate,
					instructorShared: data.instructorShared,
				};
			}

			if (data.studentShared !== undefined) {
				infoToUpdate = {
					...infoToUpdate,
					studentShared: data.studentShared,
				};
			}

			if (data.isBackgroundOff !== undefined) {
				infoToUpdate = {
					...infoToUpdate,
					isBackgroundOff: data.isBackgroundOff,
				};
			}

			try {
				updateRecordingMutation({
					variables: {
						input: {
							id: recordingId,
							...infoToUpdate,
						},
					},
					onCompleted: (data) => {
						console.log({ data });
					},
					onError: (error) => {
						console.log({ error });
					},
				});
			} catch (error) {
				console.log('error', error);
			}
		},
		[recordingId, updateRecordingMutation]
	);

	const props = useMemo(
		() => ({
			recording,
			setRecording,
			recordingStatus,
			setRecordingStatus,
			recordingId,
			setRecordingId,
			updateRecording,
		}),
		[
			recording,
			setRecording,
			recordingStatus,
			setRecordingStatus,
			recordingId,
			setRecordingId,
			updateRecording,
		]
	);

	return (
		<RecorderContext.Provider value={props}>
			{children}
		</RecorderContext.Provider>
	);
};

export const useRecordingContext = () => useContext(RecorderContext);
